import React from 'react';
import './ReportSection.scss';

interface ReportSectionProps {
  title: string;
  /** Druga połowa tytułu — łamie się do nowej linii i idzie akcentem. */
  titleAccent?: string;
  subtitle?: string;
  /** Wyróżniona konkluzja slajdu, np. „You rank 1st in AI Visibility". */
  headline?: React.ReactNode;
  /**
   * Prawa kolumna slajdu. Zaczyna się na wysokości nagłówka, więc tytuł i `children` schodzą do
   * węższej kolumny obok — używaj, gdy slajd ma dwa równorzędne bloki, a nie jedną treść pod tytułem.
   */
  aside?: React.ReactNode;
  footnote?: string;
  children: React.ReactNode;
}

/**
 * Karta jednego slajdu raportu. Wszystkie slajdy — i Checkera, i pełnego raportu — mają ten sam
 * szkielet: tytuł, opcjonalna konkluzja, treść, przypis.
 */
export const ReportSection: React.FC<ReportSectionProps> = ({
  title,
  titleAccent,
  subtitle,
  headline,
  aside,
  footnote,
  children,
}) => (
  <section className={`report-section${aside ? ' report-section--split' : ''}`}>
    <div className="report-section__main">
      <header className="report-section__header">
        <h2 className="report-section__title">
          {title}
          {titleAccent && (
            <>
              <br />
              <span className="report-section__title-accent">{titleAccent}</span>
            </>
          )}
        </h2>
        {subtitle && <blockquote className="report-section__subtitle">{subtitle}</blockquote>}
      </header>

      {headline && <p className="report-section__headline">{headline}</p>}

      <div className="report-section__body">{children}</div>
    </div>

    {aside && <div className="report-section__aside">{aside}</div>}

    {footnote && <p className="report-section__footnote">{footnote}</p>}
  </section>
);

export default ReportSection;
